/**
 * Utility to detect if the application should run in test mode
 */

// Check if the environment is development
export const isDevelopmentMode = () => {
  return process.env.NODE_ENV === 'development';
};

// Check if running on localhost
export const isLocalhost = () => {
  if (typeof window !== 'undefined') {
    return window.location.hostname === 'localhost';
  }
  return false;
};

// Determine if test mode should be enabled
export const isTestModeEnabled = () => {
  // Enable test mode in development environment or on localhost
  return isDevelopmentMode() || isLocalhost();
};

// Get test parameter for API calls
export const getTestModeParam = () => {
  if (isTestModeEnabled()) {
    return { isTest: true };
  }
  return {};
};

export default {
  isDevelopmentMode,
  isLocalhost,
  isTestModeEnabled,
  getTestModeParam
}; 